module.exports = "../../../../platform/assets/pageMainIcon/ig-basic-archives-4.svg";